<div class="toast-container position-fixed top-0 end-0 p-3">
  <div #alertToast id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header">
      <i *ngIf="showErrorAlert" class="fa-solid fa-circle-exclamation me-2"></i>
      <i *ngIf="showMessageAlert" class="fa-solid fa-circle-check  me-2"></i>
      <strong class="me-auto">{{title}}</strong>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body">
      @if (showErrorAlert) {
      <ul>
        <li *ngFor="let error of errors; let i = index"> 
          {{error.message}}
          @if (error.detail) {
          <span>: {{error.detail}}</span>
          }
        </li>
      </ul>
      }
      @if (showMessageAlert) {
      <ul>
        <li *ngFor="let message of messages; let i = index">
          {{message}}
        </li>
      </ul>
      }
    </div>
  </div>
</div>